import React from "react";
import { Checkbox, FormControlLabel } from "@mui/material";
import {
  HIDE_SYNC_BANNER_LABEL,
  hideSyncBannersForCurrentSite,
} from "../utils/syncBannerPreference";

/**
 * "Don't show again for this site" checkbox shared by both sync reminder
 * banners (SUP-924). Ticking it records the per-site, per-session preference
 * and the banner it sits in unmounts immediately — there is no separate
 * confirm step, so the box is always rendered unchecked.
 */
export const HideSyncBannerCheckbox = ({
  onHide,
}: {
  /** Extra teardown the host banner wants when it is hidden (e.g. the About page's close side effects). */
  onHide?: () => void;
}) => (
  <FormControlLabel
    control={
      <Checkbox
        size="small"
        color="default"
        checked={false}
        onChange={(_event, checked) => {
          if (!checked) return;
          hideSyncBannersForCurrentSite();
          onHide?.();
        }}
        sx={{ py: 0, color: "inherit", "&.Mui-checked": { color: "inherit" } }}
      />
    }
    label={HIDE_SYNC_BANNER_LABEL}
    sx={{
      mr: 1,
      whiteSpace: "nowrap",
      "& .MuiFormControlLabel-label": {
        fontFamily: "Mulish",
        fontSize: 13,
      },
    }}
  />
);
